import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { AddTechnologyPage } from '../../pages/add-technology/add-technology';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

   public items : any = [];
   constructor(public navCtrl: NavController,
               public http   : Http)
   {

   }


   ionViewWillEnter()
   {
      this.load();
   }

   // Retrieve the JSON encoded data from the remote server
   // Using Angular 2's Http class and an Observable - then
   // assign this to the items array for rendering to the HTML template
   load()
   {
      this.http.get('http://kasstailor.stagnoapps.com/retrieve-data.php')
      .map(res => res.json())
      .subscribe(data =>
      {
         this.items = data;
      });
   }


   // Allow navigation to the AddTechnologyPage for creating a new entry
   addEntry()
   {
      this.navCtrl.push(AddTechnologyPage);
   }


   // Allow navigation to the AddTechnologyPage for amending an existing entry
   // (We supply the actual record to be amended, as this method's parameter,
   // to the AddTechnologyPage
   viewEntry(param)
   {
      this.navCtrl.push(AddTechnologyPage, param);
   }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts